import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from 'src/app/custom-component/modal/modal.component';
import { TalktosalesComponent } from 'src/app/shared/module/talktosales/talktosales.component';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-common-talktosales-button',
  templateUrl: './talktosalesButton.component.html',
  styleUrls: ['./talktosalesButton.component.scss'],
  standalone: true,
  imports: [CommonModule, ModalComponent, TalktosalesComponent],
})
export class TalkToSalesButtonComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() text = 'Speak to sales';
  @Input() isPrimary = false;
  @Input() hubspotId!:string;
  constructor(private posthogService: PosthogService) {
    this.subscriptions = [];
  }

  _text = 'Speak to sales';
  isModalOpen = false;

  subscriptions: Subscription[];

  ngOnInit(): void {
    this._text = this.text || 'Speak to sales';
  }

  ngOnChanges(): void {
    this._text = this.text || 'Speak to sales';
    
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openTalktoSales(): void {
    this.isModalOpen = true;
    this.posthogService.captureCTAClick('talk_to_sales', 'inline', {
      ctaText: this._text
    });
  }

  closeModal(): void {
    this.isModalOpen = false;
  }
}
